import { RefObject } from 'react';
import { ToolTip } from '../../components/Tooltip/ToolTip';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import Form from '../../components/Form';
import strings from '../../common/Translation/Translate';
import useWindowSize from 'utils/hooks/useWindowSize';
import { countryList } from 'utils/constants/data';

type ActionColumnProps = {
  editRow: (idx: any) => void;
  deleteRow: (idx: any) => void;
  index: any;
  isEdit?: boolean;
  disableEdit?: boolean;
  disableDelete?: boolean;
  hideEdit?: boolean;
  hideDelete?: boolean;
};
export const ActionColumn = ({ editRow, deleteRow, isEdit = true, index, disableEdit = false, disableDelete = false, hideEdit = false, hideDelete = false }: ActionColumnProps) => (
  <>
    {isEdit && !hideEdit &&
      (<ToolTip title="Edit">
        <IconButton sx={{ p: 0, mr: 1 }} onClick={disableEdit ? () => { } : () => editRow(index)} aria-label="edit" data-testid='edit'>
          <EditIcon fontSize="small" color={disableEdit ? 'disabled' : 'primary'} />
        </IconButton>
      </ToolTip>
      )}
    {!hideDelete && <ToolTip title="Delete">
      <IconButton sx={{ p: 0 }} onClick={disableDelete ? () => { } : () => deleteRow(index)} aria-label="delete" data-testid='delete'>
        <DeleteOutlineOutlinedIcon fontSize="small" color={disableDelete ? 'disabled' : 'primary'} />
      </IconButton>
    </ToolTip>}
  </>
);

type formComponentProps = {
  hasError: any;
  handleSave: any;
  formRef: any;
  pageResponse: any;
  dropdownValue?: any;
  handleChange?: any;
  isFormUpdated?: any;
  formModel: any;
  buttonText?: string;
  /** Disable submit while a save request is in flight. */
  disabled?: boolean;
};
export const FormComponent = ({
  hasError,
  formRef,
  pageResponse,
  handleSave,
  dropdownValue = {},
  formModel,
  handleChange,
  isFormUpdated = false,
  buttonText = strings.common_button_save,
  disabled = false,
}: formComponentProps) => {
  return (
    <>
      <Grid container spacing={1.5} sx={{ my: 2 }}>
        <Form
          isFormUpdated={isFormUpdated}
          hasError={hasError}
          ref={formRef as RefObject<Form>}
          model={formModel}
          values={pageResponse}
          dropdownData={dropdownValue}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={3} lg={2}>
        <Button
          variant="contained"
          sx={{ color: '#ffffff' }}
          onClick={e => handleSave(e)}
          fullWidth
          data-testid='btn'
          disabled={disabled}>
          {buttonText}
        </Button>
      </Grid>
    </>
  );
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  disablePadding?: boolean;
}
export function TabPanel(props: TabPanelProps) {
  const { children, value, index, disablePadding, ...other } = props;
  const mobile = useWindowSize();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={disablePadding ? { p: 0 } : { p: mobile ? 0 : 1, py: mobile ? 2 : 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export const countryListWithFlag = countryList().map((c: any) => ({
  ...c,
  label:
    <Box display='flex' alignItems={'center'} gap={1.5}>
      <img
        alt="Flag_image"
        height={'20px'}
        src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${c.value}.svg`} />
      <Typography>{c.label}</Typography>
    </Box>
}))
export const FlagList = countryList().map((c: any) => ({
  ...c,
  label:
    <Box display='flex' alignItems={'center'} gap={1.5}>
      <img
        alt="Flag_image"
        height={'20px'}
        src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${c.value}.svg`} />
    </Box>
}))